import type { WorkspaceUserSearchResult } from "../workspaces/workspaceMembers.types";
import type { TenantUserSummary } from "./tenantUsers.types";

/**
 * Adapts a tenant-users search result into the shared invite-picker's
 * search-result shape (`WorkspaceUserSearchResult`), so `MemberSearchDropdown`,
 * `useMemberInvitePicker`, and `createUserInvite` need no change to accept
 * tenant-scoped results alongside workspace-scoped ones.
 */
export const mapTenantUserToSearchResult = (
  user: TenantUserSummary,
): WorkspaceUserSearchResult => ({
  id: user.user_id,
  name:
    [user.first_name, user.last_name].filter(Boolean).join(" ").trim() ||
    user.email,
  email: user.email,
  title: user.role_name,
  avatarUrl: null,
});
